import React, { useContext, useEffect, useState } from 'react';

import Banner from '../../b2b-common/Banner';
import { ButtonGroup, CircularProgress, Paper } from '@mui/material';
import { LoginContext } from '../../../App';
import { callAPIWhileSettingState, generateTextField, get_YYMMDDHHMM, handleObjectFieldChange } from '../../b2b-common/helpers';
import { FileDownload, Search } from '@mui/icons-material';

import './LabelsListPage.css';
import { getCSVFile, getLanguageList_Paged } from '../../../services/b2b-languages-apiService';
import LabelsTable from '../components/LabelsTable';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import LabelDetailsModal from '../forms/LabelDetailsModal';
import B2BDialog from '../../b2b-common/B2BDialog';
import B2BButtonGroup from '../../b2b-common/B2BButtonGroup';

const LabelsListPage = () => {
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    const [refresh, setRefresh] = useState(true);
    const [searchFields, setSearchFields] = useState({
        locale: '',
        key: '',
        content: '',
    });
    const [labelsData, setLabelsData] = useState(null);
    const [downloadingCSV, setDownloadingCSV] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);

    const { loginData } = useContext(LoginContext);

    useEffect(() => {
        if (labelsData)
            setPagesCount(labelsData.totalPages);
    }, [labelsData]);

    const fetchLabelsData = async (page) => {
        try {
            const paramsArray = [
                page - 1,
                15,
                searchFields,
                loginData.accessToken
            ];
            callAPIWhileSettingState(getLanguageList_Paged, paramsArray,
                setLoading, setLabelsData);
        } catch (error) {
            setError(error.message);
        }
    };

    useEffect(() => {
        if (page !== 0) {
            fetchLabelsData(page);
            setRefresh(false);
        }
    }, [page, refresh]);

    const handlePageChange = (event, value) => {
        setPage(value);
        setRefresh(true);
    };

    const handleClickSearch = async () => {
        fetchLabelsData(1);
        setPage(1);
    };

    const [showLabelTranslations, setShowLabelTranslations] = useState(false);
    const [labelTranslations, setLabelTranslations] = useState(null);

    const handleSelectLabel = (labelRowInTable) => {
        //console.log(labelRowInTable);
        setLabelTranslations(labelRowInTable);
        setShowLabelTranslations(true);
    };

    const handleDownloadingCSV = async () => {
        const fileName = 'b2b-labels-' + get_YYMMDDHHMM() + '.csv';
        const paramsArray = [
            searchFields,
            loginData.accessToken,
            fileName
        ];
        try {
            await callAPIWhileSettingState(getCSVFile, paramsArray,
                setDownloadingCSV, null);
        } catch (error) {
            setDialogOpen(true);
            setDialogError('Failed to download csv: ' + error.message);
        }
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDialogError(null);
    };

    const buttonsConfig = [
        {
            label: 'Search',
            disabledText: 'Search',
            onClick: handleClickSearch,
            isLoading: loading,
            color: 'secondary',
            variant: 'contained',
            key: '2',
            icon: <Search />,
        },
    ];


    const buttonConfigs = [
        {
            label: 'Download CSV',
            disabledText: 'Downloading...',
            onClick: handleDownloadingCSV,
            isLoading: downloadingCSV,
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <FileDownload />,
        },
    ];

    return (
        <div className='labels-list-page'>
            <Banner message="Languages Menu: Find matching labels" className='labels-list-page-banner' />
            <B2BFormContainer title="Search form" className="labels-search-form" orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
                {generateTextField("Locale", searchFields.locale, "labels-list-search-field-locale", false, (e) => handleObjectFieldChange('locale', e.target.value, setSearchFields), { required: false })}
                {generateTextField("Key", searchFields.key, "labels-list-search-field-key", false, (e) => handleObjectFieldChange('key', e.target.value, setSearchFields), { required: false })}
                {generateTextField("Content", searchFields.content, "labels-list-search-field-content", false, (e) => handleObjectFieldChange('content', e.target.value, setSearchFields), { required: false })}
            </B2BFormContainer>
            {loading && <CircularProgress className="centered-spinner" />}
            {error && <p>Error: {error}</p>}
            {!loading && labelsData && (
                <Paper className="labels-table-paper">
                    <LabelsTable
                        labelsPagedData={labelsData}
                        onSelectLabel={handleSelectLabel}
                        pagesCount={pagesCount}
                        currentPage={page}
                        onPageChange={handlePageChange}
                        className={'labels-table'}
                    />
                    <B2BButtonGroup buttonConfigs={buttonConfigs} />
                </Paper>
            )}
            <LabelDetailsModal
                open={showLabelTranslations}
                labelTranslations={labelTranslations}
                onLabelUpdate={() => setRefresh(true)}
                onClose={() => setShowLabelTranslations(false)}
            />
            <B2BDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                title={dialogError ? 'Error downloading CSV' : 'CSV Downloaded'}
            >
                <p>{dialogError || "The csv file has been downloaded successfully."}</p>
            </B2BDialog>
        </div>
    );
}

export default LabelsListPage;